import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

const Root = styled('div')(() => {
  return {
    display: 'flex',
    alignItems: 'stretch',
    position: 'relative',
  };
});

const ProgressIndicator = styled(CircularProgress)(() => {
  return {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  };
});

const ProgressButton = ({
  className = undefined,
  title,
  loading = false,
  fullWidth = false,
  ...other
}) => {
  return (
    <Root className={className} sx={fullWidth ? { width: '100%' } : undefined}>
      <Button
        aria-label={title}
        disabled={loading}
        fullWidth={fullWidth}
        {...other}
      >
        {title}
      </Button>
      {loading && <ProgressIndicator size={24} />}
    </Root>
  );
};

ProgressButton.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  fullWidth: PropTypes.bool,
};

export default ProgressButton;
